(function () {
    'use strict';

    angular.module("imApp").factory("currencyExRateService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1023,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1024,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
